import { useFieldReview } from "@components/QaReview/hooks/useFieldReview";
import { useSidebarView } from "@providers/SidebarViewProvider/useSidebarView";

export const useOpenReview = () => {
  const { setView } = useSidebarView();
  const { activate } = useFieldReview();

  return () => {
    setView("review");
    const firstIndicator = document.querySelector<HTMLElement>("[data-suggestion-indicator]");
    const fieldId = firstIndicator?.getAttribute("data-suggestion-indicator");
    if (!firstIndicator || !fieldId) return;
    activate(fieldId);
    firstIndicator.scrollIntoView({ behavior: "auto", block: "center", inline: "center" });
  };
};
